import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './Pill.module.scss'

const propTypes = {
  /**
   * content of the pill
   */
  children: PropTypes.node.isRequired,
  /**
   * "inactive" style of the pill
   */
  textGray: PropTypes.bool,
  /**
   * Classname to override default styles
   */
  className: PropTypes.string,
  /**
   * If true, apply default margins to the pill
   */
  withMargins: PropTypes.bool,
  /**
   * Default color scheme of the pill
   */
  variant: PropTypes.oneOf(['primary', 'secondary']),
  /**
   * Size of the pill
   */
  size: PropTypes.oneOf(['medium', 'large']),
}

const defaultProps = {
  textGray: false,
  className: '',
  withMargins: true,
  variant: 'secondary',
  size: 'medium',
}

function Pill(props) {
  const { children, textGray, className, withMargins, variant, size } = props
  return (
    <div
      className={clsx(
        withMargins && 'mr-2 mb-2',
        styles.pill,
        styles[variant],
        styles[size],
        textGray && styles.textGray,
        className,
      )}
    >
      {children}
    </div>
  )
}

Pill.propTypes = propTypes
Pill.defaultProps = defaultProps

export default Pill
